import type { ReactNode } from 'react';

interface SettingSectionProps {
  title: string;
  /** The "where does it show" line under the title. */
  where: string;
  children: ReactNode;
}

/** A titled group of setting rows, with the line saying where its effect is visible. */
export function SettingSection({ title, where, children }: SettingSectionProps) {
  return (
    <section className="mt-12 first:mt-6" aria-label={title}>
      <h2 className="font-bold text-h4 text-noir leading-tight">{title}</h2>
      <p className="mt-0 mb-3 font-light text-gray-600 text-small">{where}</p>
      {children}
    </section>
  );
}
